export function show_page_loader(message = 'Loading...', logo_src = null) {
  const loader = document.getElementById('loader');
  if (!loader) return;

  const text = loader.querySelector('.loader-text');
  if (text) text.textContent = message;

  const logo = loader.querySelector('#loader-logo-img, .loader-logo img');
  if (logo && logo_src) logo.src = logo_src;

  loader.style.display = 'flex';
  loader.classList.remove('hidden');
}

export function hide_page_loader() {
  const loader = document.getElementById('loader');
  if (!loader) return;

  loader.classList.add('hidden');
}

export const PAGE_LOADER_RESTORED_EVENT = 'aic-one:page-loader-restored';

let restore_handlers_installed = false;

export function install_page_loader_restore_handlers() {
  if (restore_handlers_installed || typeof window === 'undefined') return;

  restore_handlers_installed = true;
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hide_page_loader();
      window.dispatchEvent(new CustomEvent(PAGE_LOADER_RESTORED_EVENT));
    }
  });
}
